import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 12px;
  background: #fff;
  border: 1px solid ${(props) => props.theme.$gray300};
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(33, 53, 74, 0.06);
  padding: 10px 16px;

  .refine-head {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .refine-toggle {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: 0;
    background: transparent;
    padding: 0;
    font-size: 0.9rem;
    font-weight: 700;
    color: ${(props) => props.theme.$gray900};

    > i {
      font-size: 18px;
      color: ${(props) => props.theme.$primary_green};
    }

    .chevron {
      color: ${(props) => props.theme.$gray500};
    }

    .refine-badge {
      min-width: 20px;
      height: 20px;
      padding: 0 6px;
      border-radius: 999px;
      background: ${(props) => props.theme.$primary_green};
      color: #fff;
      font-size: 0.72rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }

  .refine-summary {
    flex: 1;
    min-width: 200px;
    font-size: 0.8rem;
    color: ${(props) => props.theme.$gray600};
  }

  .refine-clear {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    padding: 0;
    font-size: 0.8rem;
    color: ${(props) => props.theme.$gray600};

    i {
      font-size: 15px;
    }
  }

  .refine-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px 14px;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid ${(props) => props.theme.$gray200};

    @media only screen and (max-width: 992px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media only screen and (max-width: 576px) {
      grid-template-columns: 1fr;
    }
  }

  .refine-field {
    label {
      margin: 0 0 2px;
      font-size: 0.72rem;
      font-weight: 700;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      color: ${(props) => props.theme.$gray500};
    }

    .form-control-sm {
      font-size: 0.84rem;
    }
  }

  .refine-range {
    display: flex;
    align-items: center;
    gap: 6px;

    span {
      font-size: 0.78rem;
      color: ${(props) => props.theme.$gray500};
    }
  }
`;
